import { ArticleHeading } from 'helpers/articleHeadings';
import styles from './ArticleContents.module.scss';

type ArticleContentsProps = {
  headings: ArticleHeading[];
};

/** Fewer sections than this fit on one screen, so a contents list would only add noise. */
export const MIN_CONTENTS_HEADINGS = 3;

// A labelled <p>, not a heading: the list must not appear in the article's own outline.
const ArticleContents = ({
  headings,
}: ArticleContentsProps): JSX.Element | null => {
  if (headings.length < MIN_CONTENTS_HEADINGS) {
    return null;
  }

  return (
    <nav className={styles.root} aria-labelledby="article-contents">
      <p id="article-contents" className={styles.title}>
        In this article
      </p>
      <ol className={styles.list}>
        {headings.map(({ id, text }) => (
          <li key={id} className={styles.item}>
            <a href={`#${id}`} className={styles.link}>
              {text}
            </a>
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default ArticleContents;
